import { render, staticRenderFns } from "./ConfirmPassword.vue?vue&type=template&id=0caf1bbc&scoped=true&"
import script from "./ConfirmPassword.vue?vue&type=script&lang=js&"
export * from "./ConfirmPassword.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPassword.vue?vue&type=style&index=0&id=0caf1bbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caf1bbc",
  null
  
)

export default component.exports